/**
 * Allows for manipulating exisiting state properties
 * if an filtering, cleaning, etc. is needed.
 */
// import csvHelper from '@/utils/csv-helper'
import forEach from 'lodash/forEach'
import map from 'lodash/map'
import { filter } from 'lodash'

export default {

  groups (state) {
    // eslint-disable-next-line
    return _.sortBy(state.groups, (group) => {
      return group.GroupName
    })
  },

  groupCourses (state) {
    return state.groupCourses
  },

  groupCohorts (state) {
    return state.groupCoursesCohorts
  },

  allGroupData (state) {
    return state.allGroupData
  },

  selectedGroup (state) {
    return state.selectedGroup
  },

  selectedGroupCourses (state) {
    let groupCourses = state.groupCourses

    //eslint-disable-next-line
    return _.filter(groupCourses, course => {
      return course.isSelected === true
    })
  },

  selectedGroupCoursesWithNoFilter (state) {
    return state.groupCourses
  },
  /**
   * Get values for the Bar Grpah based on
   * the currently set Progress Buckets
   */
  barGraphData (state, getters) {
    let values = {}

    /* eslint-disable */
    _.forEach(state.progressBuckets, (bucket, index) => {
      let count = _.filter(getters.filteredStats, stat => {
        return  parseInt(stat.ProgressPercent) >= bucket.min &&
                parseInt(stat.ProgressPercent) <= bucket.max
      }).length

      _.set(values, `bucket${index + 1}`, count)

    })
    /* eslint-enable */

    return values
  },

  /**
   * Get labels for the Bar Graph based on
   * the currently set Progress Buckets
   */
  barGraphLabels (state) {
    let labels = {}

    state.progressBuckets.forEach((bucket, index) => {
      labels[`bucket${index + 1}`] = bucket.name
    })

    return labels
  },

  vennChartData (state, getters) {
    // let allStats = getters.filteredStats
    let groupCourses = state.selectedGroupCourses
    let groupCoursesStats = []
    let courseStats = []

    /* eslint-disable */
    _.forEach(groupCourses, course => {
      courseStats = getters.groupCourseStatsById(course.GroupCourseMasterId)
      groupCoursesStats.push({
        'sets': [course.GroupCourseMasterId],
        'label': `${courseStats.length} | ${course.CourseTitle} - ${course.CourseSubTitle}`,
        'size': courseStats.length
      })
    })
    /* eslint-enable */

    return groupCoursesStats
  },

  vennChartLabels (state, getters) {

  },

  stackedBarGraphData: (state, getters) => (chartCourse) => {
    /* eslint-disable */
    if (chartCourse === undefined) {
      return []
    }

    let filteredStats = getters.filteredStats

    /** Filter all available Stats for only those related to the selected GroupCourse */
    let courseCohortsStats = _.filter(filteredStats, stat => {
      return stat.GroupCourseMasterId === chartCourse.GroupCourseMasterId
    })

    /** Find all Cohorts under this GroupCourse */
    let availableCohortIds = _.uniq(_.map(courseCohortsStats, 'CohortId'))
    let values = {}

    _.forEach(availableCohortIds, cohortId => {
      values[cohortId] = {}

      _.forEach(state.progressBuckets, (bucket, index) => {
        values[cohortId][`bucket${index + 1}`] = state.stats.filter(
          stat => stat.CohortId === cohortId &&
          parseInt(stat.ProgressPercent) >= bucket.min &&
          parseInt(stat.ProgressPercent) <= bucket.max).length
        })
      })

      return values
      /* eslint-enable */
  },

  /**
   * Get labels for the Bar Graph based on
   * the currently set Progress Buckets
   */
  stackedBarGraphLabels (state, getters) {
    return getters.barGraphLabels
  },

  selectedCohorts (state) {
    return state.selectedCohorts
  },

  /**
   * Get Filtered records/stats for the table based on which
   * GroupCourses and Cohorts are selected.
   *
   * @param {Object} state The State Object
   * @returns {Array}
   */
  filteredStats (state, getters) {
    let allStats = state.stats
    let currDashboardTabSelection = state.currDashboardTabSelection
    let selectedCohorts = state.selectedCohorts
    let selectedCohortsIds = []
    let filteredStats = []
    // AK: Pick only those cohorts which are currently selected
    selectedCohorts = filter(selectedCohorts, (obj) => {
      return obj.isSelected === true
    })
    if (selectedCohorts.length === 0) {
      return []
    }

    selectedCohortsIds = map(selectedCohorts, cohort => { return cohort.CohortId })
    switch (currDashboardTabSelection) {
      default:
      case 1:
        /* eslint-disable */
        filteredStats = _.filter(allStats, (stat) => {
          if (getters.userIsGroupAdmin) {
            return _.includes(selectedCohortsIds, stat.CohortId) &&
              !_.includes(stat.Email, '@personalleadership.com')
          } else if (getters.userIsAdmin) {
            return _.includes(selectedCohortsIds, stat.CohortId)
          }
        })
        /* eslint-enable */
        break
      case 2:
        filteredStats = []
        forEach(allStats.GroupProgressDataList, (obj1) => {
          forEach(obj1.CohortProgressDataList, (obj2) => {
            if (selectedCohortsIds.indexOf(obj2.CohortId) > -1 && obj2.isSelected === true) {
              filteredStats.push(obj2)
            }
          })
        })
        break
    }
    return filteredStats
  },

  cohortNameById: (state) => (cohortId) => {
    // eslint-disable-next-line
    return _.find(state.stats, ['CohortId', cohortId]).CohortTitle
  },

  /**
   * Get all Stats for the given GroupCourses. Argument
   * can be passed as a String or Array of Strings.
   *
   * @param {String|Array} groupCourseIds GroupCourseMasterIds for all target GroupCourses
   * @returns {Array}
   */
  groupCourseStatsById: (state, getters) => {
    return (groupCourseIds) => {
      let results = []

      // eslint-disable-next-line
      if (_.isArray(groupCourseIds)) {
        groupCourseIds.forEach(id => {
          // eslint-disable-next-line
          _.merge(results, getters.groupCourseStatsById(id))
        })

        return results
        // eslint-disable-next-line
      } else if (_.isString(groupCourseIds)) {
        // eslint-disable-next-line
        return _.filter(state.stats, ['GroupCourseMasterId', groupCourseIds])
      }
    }
  },

  /**
   * Generates data for the PolarAreaChart
   *
   * @param {String|Number} qualPercent The qualifying percentage
   * @param {Boolean}       includeQual Include stats with 'progress == qualPercent'(or not)
   */
  polarAreaChartData: (state, getters) => {
    return (qualPercent, includeQual) => {
      let totalCourseStats = []
      let qualCourseStats = []
      let results = []
      let groupCourses = state.selectedGroupCourses

      // eslint-disable-next-line
      _.forEach(groupCourses, (course) => {
        totalCourseStats = getters.groupCourseStatsById(course.GroupCourseMasterId)

        if (totalCourseStats.length > 0) {
          // eslint-disable-next-line
          qualCourseStats = _.filter(totalCourseStats, stat => {
            if (includeQual) {
              return parseInt(stat.ProgressPercent) >= parseInt(qualPercent)
            } else {
              return parseInt(stat.ProgressPercent) > parseInt(qualPercent)
            }
          })

          // eslint-disable-next-line
          results[course.CourseTitle] = _.round((qualCourseStats.length / totalCourseStats.length), 2)
          // results[course.CourseTitle] = qualCourseStats.length
        }
      })

      return results
    }
  },

  pieChartData (state, getters) {
    let results = {}
    let groupCourses = state.selectedGroupCourses

    // eslint-disable-next-line
    _.forEach(groupCourses, (course) => {
      results[course.CourseTitle] = getters.groupCourseStatsById(course.GroupCourseMasterId).length
    })

    return results
  },

  topBy: (state, getters) => {
    return (propName, number) => {
      let sortedStats = []

      /* eslint-disable */
      if (propName) {
        sortedStats = _.sortBy(getters.filteredStats, (stat) => { return parseInt(stat[propName]) })
      } else {
        sortedStats = _.sortBy(getters.filteredStats, (stat) => { return parseInt(stat.ProgressPercent) })
      }

      return _.takeRight(sortedStats, number)
      /* eslint-enable */
    }
  },

  /**
   * Returns true if the currently Authenticated User is a GroupAdmin.
   * Otherwise returns false.
   *
   * @returns {Boolean}
   */
  userIsGroupAdmin (state) {
    return (state.curr_user.AccountType === 1)
  },

  currDashboardTabSelection (state) {
    return parseInt(state.currDashboardTabSelection)
  },

  /**
   * Returns true if the currently Authenticated User is an Admin.
   * Otherwise returns false.
   *
   * @returns {Boolean}
   */
  userIsAdmin (state) {
    return (state.curr_user.AccountType === 2)
  },

  /**
   * Returns data for exporting the Dashboard.
   * TODO: MAKE THIS WORK
   */
  allDashboardExports (state, getters) {
    let results = {}
    const reports = [
      'cumulative_progress_distribution',
      'cohort_wise_progress_distribution',
      'course_total_population',
      'course_qualifying_population',
      'leaderboard'
    ]

    /* eslint-disable */
    _.forEach(reports, (report) => {
      let methodName = `${_.camelCase(report)}Exports`

      if (typeof getters[methodName] === 'undefined') {
        // console.log(`Getter named '${methodName}' does not exist!`)
      } else {
        results['reportName'] = getters[methodName]
      }
    })

    return results
    /* eslint-enable */
  },

  /**
   * Returns data for the Cumulative Progress Dist. Report
   *
   * @param {Object} state   The Vuex State object.
   * @param {Object} getters All available Getters.
   *
   * @returns {Object}
   */
  cumulativeProgressDistributionExports (state, getters) {
    let labelsObj = getters.barGraphLabels
    let valuesObj = getters.barGraphData
    let rows = []
    let columns = []
    let value = {}

    // eslint-disable-next-line
    _.forIn(labelsObj, (labelText, labelID) => {
      value[labelText] = valuesObj[labelID]
      columns.push(labelText)
    })
    rows.push(value)

    return { rows, columns }
  },

  /**
   * Returns data for the Cohort-wise Progress Dist. Report
   *
   * @param {Object} state   The Vuex State object.
   * @param {Object} getters All available Getters.
   *
   * @returns {Object}
   */
  cohortWiseProgressDistributionExports (state, getters) {
    // let labelsObj = getters.barGraphLabels
    let selectedCourses = getters.selectedGroupCourses
    let results = []

    // eslint-disable-next-line
    _.forEach(selectedCourses, (course) => {
      results.push(getters.stackedBarGraphData(course))
    })

    return results
  },

  cohortsByCourseId (state, getters) {
    return groupCourseMasterId => {
      // eslint-disable-next-line
      return _.uniq(_.filter(state.groupCoursesCohorts, cohort => {
        return cohort.GroupCourseMasterId === groupCourseMasterId
      }))
    }
  },

  courseById (state, getters) {
    return groupCourseMasterId => {
      // eslint-disable-next-line
      return _.find(state.groupCourses, course => {
        return course.GroupCourseMasterId === groupCourseMasterId
      })
    }
  },

  userIsInternal (state, getters) {
    return (getters.userIsAdmin || getters.userIsGroupAdmin) &&
      // eslint-disable-next-line
      _.includes(state.curr_user.Email, '@personalleadership.com')
  }

}



// WEBPACK FOOTER //
// ./src/store/getters.js